import styled from 'styled-components';

export const Container = styled.div`
    width: 300px;
    max-height: 300px;
    overflow: hidden;
    overflow-y: scroll;
}
`;

export const Header = styled.div`
    height: 40px;
    border-bottom: 1px solid #f0f0f0;
    > button {
        float: right;
    }
}
`;
